/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react'
import { View } from 'react-native'
import { initialGameInfo } from '../../App'
import Card from '../Card/Card'
import TrashCan from '../TrashCan/TrashCan'
import { getNumCardSlots, getCardSlotData } from '../CardSlots/CardSlots'
import { cards } from '../../assets/cards'

const Deck = (props) => {
  const [cardsOnDeck, setCardsOnDeck] = useState([])
  const [trashCanActive, setTrashCanActive] = useState(false)

  let deck = useRef([]).current

  let card1ID = useRef(-1).current
  let card2ID = useRef(-1).current
  let card3ID = useRef(-1).current

  let cardsDragged = useRef(0).current

  function shuffle (array) {
    let currentIndex = array.length; let randomIndex

    // While there remain elements to shuffle.
    while (currentIndex > 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex--

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]]
    }

    return array
  }

  function canCardGetMoreReductionsOrSavings (cardIndex) {
    const color = deck[cardIndex].color
    const co2 = deck[cardIndex].co2
    const money = deck[cardIndex].cash
    const numSlots = getNumCardSlots()

    for (let index = 0; index < numSlots; index++) {
      const slotData = getCardSlotData(index)
      const isSlotUsed = props.usedSlots[index]
      const isRedSlotPlayable = slotData.c.includes('r') && color === 'r'
      const isBlueSlotPlayable = slotData.c.includes('b') && color === 'b'
      const isYellowSlotPlayable = slotData.c.includes('y') && color === 'y'
      const projectHasCo2Available = props.gameInfo['co2' + slotData.p] > 0
      const projectHasCashAvailable = props.gameInfo['cash' + slotData.p] > 0

      if (!isSlotUsed && (isRedSlotPlayable || isBlueSlotPlayable || isYellowSlotPlayable)) {
        if ((co2 > 0 && projectHasCo2Available) || (money > 0 && projectHasCashAvailable)) return true
      }
    }
    return false
  }

  function isPossibleToGetMoreReductionsOrSavings (numPlayableCards) {
    for (let i = 0; i < numPlayableCards; i++) {
      if (canCardGetMoreReductionsOrSavings(i)) return true
    }
    return false
  }

  const handleOnEndDrag = (isCardDragged, index, co2Reductions, cashSavings) => {
    if (isCardDragged) {
      cardsDragged = cardsDragged + 1

      if (cardsDragged % 3 === 0) {
        deal()
      }
    }

    setTrashCanActive(false)
    props.onEndDrag(isCardDragged, index, co2Reductions, cashSavings)

    const numPlayableCards = initialGameInfo.cardsLeft - cardsDragged

    if (!isPossibleToGetMoreReductionsOrSavings(numPlayableCards)) {
      props.onGameFinished()
    }
  }

  const handleEnterTrashcan = (val) => {
    setTrashCanActive(val)
  }

  const deal = () => {
    if (initialGameInfo.cardsLeft - cardsDragged < 3) return

    card1ID = initialGameInfo.cardsLeft - cardsDragged - 1
    card2ID = initialGameInfo.cardsLeft - cardsDragged - 2
    card3ID = initialGameInfo.cardsLeft - cardsDragged - 3

    setCardsOnDeck((prevCardsOnDeck) => {
      return prevCardsOnDeck.map((val, i) => {
        if (i === card1ID) {
          return <Card key={'dcard' + i} id={'dcard' + i} usedSlots={props.usedSlots} onDisableInfo={() => props.onDisableInfo(0)} onEnterTrashCan={handleEnterTrashcan} {...val.props} onAnimationBegin={props.onCardBeginDeal} onAnimationEnd={() => props.onCardDealt(0, deck[card1ID].id)} duration={800} target={dealTargets[0]} delay={500} />
        } else if (i === card2ID) {
          return <Card key={'dcard' + i} id={'dcard' + i} usedSlots={props.usedSlots} onDisableInfo={() => props.onDisableInfo(1)} onEnterTrashCan={handleEnterTrashcan} {...val.props} onAnimationBegin={props.onCardBeginDeal} onAnimationEnd={() => props.onCardDealt(1, deck[card2ID].id)} duration={650} target={dealTargets[1]} delay={1500} />
        } else if (i === card3ID) {
          return <Card key={'dcard' + i} id={'dcard' + i} usedSlots={props.usedSlots} onDisableInfo={() => props.onDisableInfo(2)} onEnterTrashCan={handleEnterTrashcan} {...val.props} onAnimationBegin={props.onCardBeginDeal} onAnimationEnd={() => props.onCardDealt(2, deck[card3ID].id)} duration={500} target={dealTargets[2]} delay={2500} />
        } else {
          return val
        }
      })
    })
  }

  useEffect(() => {
    deck = shuffle(cards)
    setCardsOnDeck(
      deck.map((card, i) => {
        return <Card key={'card' + i} id={'card' + i} {...card} {...cardStartPositions[i]} onBeginDrag={props.onBeginDrag} onEndDrag={handleOnEndDrag} />
      })
    )
    deal()
  }, [])

  return (
    <View style={styles.deck}>
        <TrashCan isActive={trashCanActive} />
        {cardsOnDeck}
    </View>
  )
}

const styles = {
  deck: {
    position: 'absolute',
    top: 0,
    left: 0
  }
}

export default Deck

const dealTargets = [{ x: 780, y: 443 }, { x: 600, y: 335 }, { x: 420, y: 443 }]

const cardStartPositions = [
  { pos: { x: 405, y: 310 }, rot: 0 },
  { pos: { x: 405, y: 310 }, rot: 0 },
  { pos: { x: 405, y: 310 }, rot: 0 },
  { pos: { x: 405, y: 310 }, rot: 0 },
  { pos: { x: 405, y: 310 }, rot: 0 },
  { pos: { x: 405, y: 310 }, rot: 0 },
  { pos: { x: 405, y: 310 }, rot: 0 },
  { pos: { x: 405, y: 310 }, rot: 0 },

  { pos: { x: 410, y: 300 }, rot: 0.05 },
  { pos: { x: 410, y: 300 }, rot: 0.05 },
  { pos: { x: 410, y: 300 }, rot: 0.05 },
  { pos: { x: 410, y: 300 }, rot: 0.05 },
  { pos: { x: 410, y: 300 }, rot: 0.05 },
  { pos: { x: 410, y: 300 }, rot: 0.05 },
  { pos: { x: 410, y: 300 }, rot: 0.05 },
  { pos: { x: 410, y: 300 }, rot: 0.05 },

  { pos: { x: 417, y: 295 }, rot: 0.11 },
  { pos: { x: 417, y: 295 }, rot: 0.11 },
  { pos: { x: 417, y: 295 }, rot: 0.11 },
  { pos: { x: 417, y: 295 }, rot: 0.11 },
  { pos: { x: 417, y: 295 }, rot: 0.11 },
  { pos: { x: 417, y: 295 }, rot: 0.11 },
  { pos: { x: 417, y: 295 }, rot: 0.11 },
  { pos: { x: 417, y: 295 }, rot: 0.11 }
]
